import React from 'react';
import { useGame } from '../../context/GameContext';

const CARD_BACK_IMAGES = {
  badbunny: '/card-back-badbunny.jpg',
};

function CardBack() {
  const { state } = useGame();
  const backStyle = state.cardBack || 'classic';
  const customSrc = state.customCardBack;

  if (backStyle === 'custom' && customSrc) {
    return (
      <div className="card-back">
        <img className="card-back__img" src={customSrc} alt="" />
      </div>
    );
  }

  const imageSrc = CARD_BACK_IMAGES[backStyle];
  if (imageSrc) {
    return (
      <div className="card-back">
        <img className="card-back__img" src={imageSrc} alt="" />
      </div>
    );
  }

  return (
    <div className="card-back card-back--classic">
      <div className="card-back__pattern" />
    </div>
  );
}

export default CardBack;
